// extracted by mini-css-extract-plugin
export default {"logo":"naem-logo_logo__PEX8"};